module.exports = __webpack_public_path__ + "img/ANGELES.5fcfb8df.png";